import { Component } from '@angular/core';

@Component({
  selector: 'app-investors-center',
  templateUrl: './investors-center.component.html',
  styleUrl: './investors-center.component.scss'
})
export class InvestorsCenterComponent {

}
